import { render, staticRenderFns } from "./WebsiteLimitReachedModal.vue?vue&type=template&id=2f552591&"
import script from "./WebsiteLimitReachedModal.vue?vue&type=script&lang=js&"
export * from "./WebsiteLimitReachedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports